// extracted by mini-css-extract-plugin
export default {"status":"Status_status__kC2M0","text":"Status_text__NTWbh","hasIcon":"Status_hasIcon__hk-gs","icon":"Status_icon__GM67Z"};